enum PersonaType {
    DrizzlyEvening = "drizzly evening",
    MoonlessNight = "moonless night",
    ShootingStar = "shooting star",
    PassingHurricane = "passing hurricane",
    BlossomWind = "blossom in the wind",
    NoClouds = "not a cloud in the sky",
    LeavesChange = "the leaves changing colour",
    DormantVolcano = "dormant volcano",
    BabblingBrook = "babbling brook",
    SturdyOak = "sturdy oak"
}

export { PersonaType }